import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './change_tariff.component.html'
})
export class ChangeTariffModalComponent extends BaseSupportModalComponent {
	domainUrl: string;
	siteId: string;
	i18nTariffs: any;
	tariffs: any[];
	invoiceNumber: string = '';
	dateToFormatted: string = '';
	tariffId: string = '';
	newTariffId: string = '';
	currency: string = '';
	recurrentProfile: string = '';

	async ok() {
		if (confirm(`Вы уверены, что хотите изменить тариф для сайта ${this.domainUrl}?`)) {
			await this.supportService.changeTariff(this.siteId, this.newTariffId, this.spreader.base.comment).toPromise();
			
			this.execute();
		}
	}
}
